import React from "react";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
import GeneralInputWrapper from "../GeneralInputWrapper/GeneralInputWrapper";
import styles from "./TimeInput.module.scss";
const TimeInput = ({
  id,
  value,
  isError,
  onChange,
  wuiltContext
}) => {
  const hour = value?.split(":")[0].toString();
  const minute = value?.split(":")[1].split(" ")[0];
  const period = value?.split(" ")[1] || "AM";
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.timeInputContainer}`
  }, /*#__PURE__*/React.createElement(GeneralInputWrapper, {
    isError: isError,
    wuiltContext: wuiltContext
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.hours,
    id: id,
    type: "number",
    min: 0,
    max: 12,
    placeholder: "HH",
    value: hour,
    onChange: event => {
      let value = +event?.target?.value;
      value = Math.min(+value, 12);
      value = Math.max(+value, 0);
      onChange?.(`${value.toString().padStart(2, "0")}:${minute || "00"} ${period}`);
    }
  }), isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null)), /*#__PURE__*/React.createElement(GeneralInputWrapper, {
    isError: isError,
    wuiltContext: wuiltContext
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    className: styles.minutes,
    min: 0,
    max: 59,
    placeholder: "MM",
    value: minute,
    onChange: event => {
      let value = +event?.target?.value;
      value = Math.min(+value, 59);
      value = Math.max(+value, 0);
      onChange?.(`${hour || "00"}:${value.toString().padStart(2, "0")} ${period}`);
    }
  }), isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null)), /*#__PURE__*/React.createElement(GeneralInputWrapper, {
    isError: isError,
    wuiltContext: wuiltContext
  }, /*#__PURE__*/React.createElement("select", {
    className: styles.selectPmAm,
    value: period,
    onChange: event => {
      const value = event?.target?.value;
      onChange?.(`${hour}:${minute} ${value}`);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "AM"
  }, "AM"), /*#__PURE__*/React.createElement("option", {
    value: "PM"
  }, "PM"))));
};
export default TimeInput;
//# sourceMappingURL=TimeInput.js.map